import { ReactElement } from "react";
import { UiLOneColumn } from "@rotorstudios/fe-ui";

import { UiDynamicRenderer } from "../../_common/modules/fe-ui/UiDynamicRenderer";
import useCustomise from "./useCustomise";

import "./_Customise.scss";

const Customise = (): ReactElement => {
  const { headerContent, mainContent, footerContent } = useCustomise();
  const getHeaderContent = () => <UiDynamicRenderer data={headerContent} />;
  const getMainContent = () => <UiDynamicRenderer data={mainContent} />;
  const getFooterContent = () => <UiDynamicRenderer data={footerContent} />;

  return (
    <div className="Customise">
      <UiLOneColumn
        headerContent={getHeaderContent()}
        mainContent={getMainContent()}
        footerContent={getFooterContent()}
      />
    </div>
  );
};

export default Customise;
